import AvatarMui from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

export default function Section({
  mini = false,
  paper = false,
  disablePadding = false,
  flushContent = false,
  title,
  action,
  icon,
  sx,
  children,
}) {
  const content = paper ? <Paper variant="outlined">{children}</Paper> : children

  if (mini) {
    return (
      <Stack spacing={1} sx={sx}>
        <Title mini title={title} icon={icon} action={action} />
        {content}
      </Stack>
    )
  }

  if (disablePadding) {
    return (
      <Paper sx={sx}>
        <Stack>
          <Title title={title} icon={icon} action={action} sx={{ px: { xs: 2, lg: 3 }, pt: { xs: 2, lg: 3 }, pb: 2 }} />
          {content}
        </Stack>
      </Paper>
    )
  }

  if (flushContent) {
    return (
      <Paper sx={sx}>
        <Stack spacing={{ xs: 1, lg: 2 }}>
          <Box sx={{ px: { xs: 2, lg: 3 }, pt: { xs: 2, lg: 3 } }}>
            <Title title={title} icon={icon} action={action} />
          </Box>
          {content}
        </Stack>
      </Paper>
    )
  }

  return (
    <Paper sx={sx}>
      <Stack spacing={{ xs: 1, lg: 2 }} sx={{ p: { xs: 2, lg: 3 } }}>
        <Title title={title} icon={icon} action={action} />
        {content}
      </Stack>
    </Paper>
  )
}

function Title({ mini = false, title, icon, action, sx }) {
  if (!title) return null

  return (
    <Stack direction="row" spacing={2} sx={[{ alignItems: 'center', justifyContent: 'space-between' }, sx]}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        {icon && <AvatarMui sx={{ backgroundColor: 'background.paper', color: 'text.primary' }}>{icon}</AvatarMui>}
        <Typography variant={mini ? 'h5' : 'h4'}>{title}</Typography>
      </Stack>
      {action}
    </Stack>
  )
}
